export default "__VITE_ASSET__ca94580c__"